module.exports = __webpack_public_path__ + "img/loading.a2a3aeb2.gif";